import React from "react";
import { Header } from "semantic-ui-react";

import "./style.css";

const Contact = () => {
    return (
        <>
            <Header as="h1" id="contact-header">Contact</Header>
        </>
    );
};

export default Contact;